import { Action, createReducer, on } from "@ngrx/store";

import * as ProfessionalFuelActionTypes from "../../actions/professional-fuel/professional-fuel.actions";

import {
  ProfessionalFuelDTO,
  ProfessionalFuelTotalizerDTO,
} from "src/app/models/ProfessionalFuel/professionalFuelDTO";

export interface ProfessionalFuelState {
  professionalFuelList: ProfessionalFuelDTO[];
  generatedProfessionalFuelList: any;
  isLoading: boolean;
  total: number;
  totalizer: ProfessionalFuelTotalizerDTO;
  error: Error;
  dates: any;
  partyCode: string;
}

export const initialState: ProfessionalFuelState = {
  professionalFuelList: null,
  generatedProfessionalFuelList: null,
  isLoading: false,
  error: null,
  total: 0,
  totalizer: null,
  dates: null,
  partyCode: null,
};

const professionalFuelReducer = createReducer(
  initialState,
  on(ProfessionalFuelActionTypes.resetProfessionalFuel, () => initialState),
  on(ProfessionalFuelActionTypes.resetProfessionalFuelTotalizer, (state) => {
    return {
      ...state,
      totalizer: null,
      error: null,
    };
  }),
  on(
    ProfessionalFuelActionTypes.getProfessionalFuelData,
    (state, { dates, options }) =>
      ({
        ...state,
        error: null,
        options: options,
        dates: dates,
        isLoading: true,
      } as ProfessionalFuelState)
  ),
  on(
    ProfessionalFuelActionTypes.getProfessionalFuelEsData,
    (state, { dates, partyCode, options }) =>
      ({
        ...state,
        error: null,
        options: options,
        dates: dates,
        partyCode: partyCode ?? undefined,
        isLoading: true,
      } as ProfessionalFuelState)
  ),
  on(
    ProfessionalFuelActionTypes.loadProfessionalFuelData,
    (state, { response }) => {
      return {
        ...state,
        professionalFuelList: (response as any)?.result?.items
          ? (response as any)?.result?.items
          : undefined,
        error: null,
        total: (response as any)?.result?.size ?? 0,
        totalizer: (response as any)?.result?.totalizers ?? undefined,
        isLoading: false,
      };
    }
  ),
  on(
    ProfessionalFuelActionTypes.getGenerateProfessionalFuelData,
    ProfessionalFuelActionTypes.getGenerateProfessionalFuelEsData,
    (state) =>
      ({
        ...state,
        generatedProfessionalFuelList: undefined,
        error: null,
      } as ProfessionalFuelState)
  ),
  on(
    ProfessionalFuelActionTypes.loadGenerateProfessionalFuelData,
    (state, { response }) => {
      return {
        ...state,
        generatedProfessionalFuelList: (response as any)
          ? (response as any)
          : undefined,
        error: null,
      };
    }
  ),
  on(ProfessionalFuelActionTypes.setLoadingProfessionalStart, (state) => {
    return {
      ...state,
      isLoading: true,
      error: null,
    };
  }),
  on(ProfessionalFuelActionTypes.setLoadingProfessionalEnd, (state) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  })
);

export function reducer(
  state: ProfessionalFuelState | undefined,
  action: Action
) {
  return professionalFuelReducer(state, action);
}
